<template>
    <div></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {}, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {}, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['success', 'error']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the success has been updated
         *
         * @return {void}
         */
        success(value) {
            // check if the value is not empty
            // and reset after time interval
            if (value !== null && value !== undefined) {
                this.$toasted.success(value)
                this.$store.commit('reloadList', false)
                this.$store.commit('hidePopup', false)

                setTimeout(this.dismissAlert, 3000)
            }
        },
        /**
         * Handle when the error has been updated
         *
         * @return {void}
         */
        error(value) {
            // check if the value is not empty
            // and reset after time interval
            if (value !== null && value !== undefined) {
                this.$toasted.error(value)
                this.$store.commit('onSubmit', null)
                setTimeout(this.$store.commit('clearError'), 3000)
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the alert is closed by user
         *
         * @return {void}
         */
        dismissAlert() {
            // reset the success message when user dismisses alert
            this.$store.commit('clearSuccess')
            // reset the error message when user dismisses alert
            this.$store.commit('clearError')
            // clear the selected item
            this.$store.commit('clearItem')
            // enable the spinner
            this.$store.commit('setLoading', false)
            this.$store.commit('onSubmit', null)
            this.$parent.$parent.reset = new Date().getTime()
            // hide its parent if hide method exists
            // if (typeof this.$parent.hide === 'function') {
            //     this.$parent.hide()
            // } else {
            //     this.$parent.$parent.hide()
            // }
            // hide popup
            this.$store.commit('hidePopup', true)

            // reload the list
            this.$store.commit('reloadList', true)
        }, // End of dismissAlert() method
    }, // End of Component > mounted
}
</script>
